import { render, staticRenderFns } from "./ReportsDesigner.vue?vue&type=template&id=500e1456"
import script from "./ReportsDesigner.vue?vue&type=script&lang=js"
export * from "./ReportsDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports